<template>
  <transition name="fade" mode="out-in">
    <div class="custom-modal"
         :class="{'overflowed': bodyVisible}"
         v-if="visible"
         ref="backdrop"
         @click="handleBackdropClick">
      <transition name="fade" mode="out-in">
        <div class="custom-modal__container"
             :class="sizeClass"
             v-if="bodyVisible">
          <button v-if="$props.closeButtonVisible"
                  class="custom-modal__header--close"
                  tabindex="-1"
                  @click="closeModal">
            <img src="/assets/images/modal-close.svg">
          </button>
          <div class="custom-modal__header" v-if="$props.title || $slots.header">
            <div class="custom-modal__header--slot">
              <slot name="header">
                <i v-if="$props.icon"
                   class="custom-modal__header--icon"
                   :class="$props.icon"></i>
                {{ $props.title }}
              </slot>
            </div>
          </div>
          <div class="custom-modal__body custom-scrollbar">
            <slot></slot>
          </div>
          <div class="custom-modal__actions" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  data () {
    return {
      bodyVisible: false
    }
  },
  props: {
    closeButtonVisible: {
      type: Boolean,
      default: true
    },
    preventBackdropClose: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'normal',
      validator: (value) => {
        const sizes = ['normal', 'xs', 'sm', 'mdsm', 'md', 'lg', 'full']
        return sizes.indexOf(value) > -1
      }
    }
  },
  computed: {
    sizeClass () {
      return {
        [`size-${this.$props.size}`]: this.$props.size
      }
    }
  },
  methods: {
    closeModal () {
      this.$emit('modal-close')
      setTimeout(() => {
        this.$emit('modal-closed')
      }, 150)
    },
    handleBackdropClick (e) {
      if (e.target === this.$refs.backdrop && !this.$props.preventBackdropClose) this.closeModal()
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        document.body.classList.add('vue-modal-open')
        document.getElementsByTagName('html')[0].classList.add('vue-modal-open')
        setTimeout(() => {
          this.bodyVisible = true
          this.$emit('modal-opened')
        }, 150)
      } else {
        document.body.classList.remove('vue-modal-open')
        document.getElementsByTagName('html')[0].classList.remove('vue-modal-open')
        this.bodyVisible = false
        this.closeModal()
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./modal.scss"></style>
